import React from 'react'
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs"
import DepartmentOverview from './department_overview';
import StockPointOverview from './stockpoint_overview';
import InventoryEngagement from './inventory_engagement';

const tabTriggerClass = "border-0 rounded-none px-3 bg-transparent text-foreground transition-all duration-200 ease-in-out data-[state=active]:border-b-2 data-[state=active]:border-b-primary data-[state=active]:text-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:rounded-none";

const Page = () => {

    return (
        <div
            className='flex h-full w-full items-center justify-center'
        >
            <div className='w-2/3'>
                <div
                    className='flex flex-col w-full'
                >
                    <p className='text-3xl xl:text-5xl'>Here&apos;s what&apos;s happening</p>
                    <Tabs defaultValue="option1" className="mt-4">
                        <TabsList className="bg-transparent p-0 h-auto min-h-0 shadow-none border-none gap-0">
                            <TabsTrigger
                                value="option1"
                                className={tabTriggerClass}
                            >
                                Branch Overview
                            </TabsTrigger>
                            <TabsTrigger
                                value="option2"
                                className={tabTriggerClass}
                            >
                                Stock Point Overview
                            </TabsTrigger>
                            <TabsTrigger
                                value="option3"
                                className={tabTriggerClass}
                            >
                                Inventory Engagement
                            </TabsTrigger>
                        </TabsList>
                        <TabsContent value="option1">
                            <DepartmentOverview />
                        </TabsContent>
                        <TabsContent value="option2">
                            <StockPointOverview />
                        </TabsContent>
                        <TabsContent value="option3">
                            <InventoryEngagement />
                        </TabsContent>
                    </Tabs>
                </div>
            </div>
        </div>
    )
}

export default Page